import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";

const Actions = ({ rowData }) => {
  const navigate = useNavigate();

  return (
    <span className="flex flex-row justify-center">
      <Tooltip title="ویرایش سرویس" arrow={true} placement="bottom">
        <IconButton
          onClick={() =>
            navigate("/services/edit-service", {
              state: rowData,
            })
          }
        >
          <EditIcon className="text-yellow-400" />
        </IconButton>
      </Tooltip>
      <Tooltip title="مشاهده پیام‌های تیکت" arrow={true} placement="bottom">
        <IconButton
          sx={{ mx: "0.25rem" }}
          onClick={() =>
            navigate("/services/ticket", {
              state: rowData,
            })
          }
        >
          <QuestionAnswerIcon className="text-green-500" />
        </IconButton>
      </Tooltip>
    </span>
  );
};

export default Actions;
